// Shared by the dashboard and GTM billing/documents. Amounts are integer cents.
function rolloutStages(assignments) {
  const months = [...new Set(assignments.map(a => a.startMonth))].sort((a, b) => a - b);
  return months.map(month => {
    const active = assignments.filter(a => a.startMonth <= month);
    const quantities = {};
    for (const a of active) quantities[a.priceId] = (quantities[a.priceId] || 0) + 1;
    return { month, quantities, locationIndices: [...new Set(active.map(a => a.locationIndex))], additions: assignments.filter(a => a.startMonth === month) };
  });
}

function validateProductRollout(quote) {
  const rollout = quote.productRollout;
  if (rollout == null) return;
  if (!Array.isArray(rollout) || !rollout.length) throw new Error('Assign at least one product to the rollout.');
  if (!['new_business', 'expansion'].includes(quote.dealType || 'new_business') || quote.billingMode === 'invoice_net30' || quote.existingStripeSubscriptionId) throw new Error('Product rollouts are supported for standard new-business and expansion quotes.');
  if (quote.rolloutPhases?.length) throw new Error('Use either a location ramp or a product rollout.');
  const locations = new Set((quote.locations || []).map(l => l.index));
  if (!Number.isInteger(quote.quantity) || quote.quantity < 1 || locations.size !== quote.quantity || (quote.locations || []).length !== quote.quantity) throw new Error('Locations must match the quote quantity.');
  const prices = new Set(quote.stripePriceIds || []);
  const pairs = new Set();
  const assignedLocations = new Set();
  const assignedPrices = new Set();
  for (const a of rollout) {
    if (!a || !Number.isInteger(a.locationIndex) || !locations.has(a.locationIndex) || !prices.has(a.priceId)) throw new Error('Each rollout assignment must reference a quote location and selected product.');
    if (!Number.isInteger(a.startMonth) || a.startMonth < 1) throw new Error('Start months must be positive whole numbers.');
    const pair = `${a.locationIndex}:${a.priceId}`;
    if (pairs.has(pair)) throw new Error('A product can only be assigned once to each location.');
    pairs.add(pair); assignedLocations.add(a.locationIndex); assignedPrices.add(a.priceId);
  }
  if (assignedLocations.size !== locations.size) throw new Error('Assign at least one product to every location.');
  if (assignedPrices.size !== prices.size) throw new Error('Assign every selected product to at least one location, or remove it.');
  const stages = rolloutStages(rollout);
  if (stages[0].month !== 1) throw new Error('At least one product must start in month 1.');
  if (stages.length > 10) throw new Error('A rollout can have at most 10 distinct billing stages.');
  if (!Number.isInteger(quote.billingDeferralDays || 0) || (quote.billingDeferralDays || 0) < 0) throw new Error('Billing deferral must be a non-negative whole number.');
}

function priceRollout(assignments, prices, priceDiscounts = {}, discountPercent = 0) {
  const cents = Object.fromEntries(prices.map(p => [p.id, Math.max(0, Math.round(p.unitAmount * 100) - Math.round((priceDiscounts[p.id] || 0) * 100))]));
  return rolloutStages(assignments).map(stage => {
    const lines = Object.entries(stage.quantities).map(([priceId, quantity]) => {
      if (cents[priceId] === undefined) throw new Error('Missing price for rollout product.');
      const subtotal = cents[priceId] * quantity;
      return { priceId, quantity, unitAmountCents: cents[priceId], totalCents: subtotal - Math.round(subtotal * discountPercent / 100) };
    });
    return { ...stage, lines, totalCents: lines.reduce((sum, line) => sum + line.totalCents, 0) };
  });
}

function rolloutSummary(stages, fixedCents = 0, deferralDays = 0) {
  return (deferralDays > 0 ? `First ${deferralDays} days complimentary; Month 2 begins when this period ends. ` : '') +
    'Monthly rates: ' + stages.map(s => `Month ${s.month}: $${((s.totalCents + fixedCents) / 100).toFixed(2)}`).join('; ') + '. One-time fees are separate.';
}
module.exports = { rolloutStages, validateProductRollout, priceRollout, rolloutSummary };
